import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../../core/auth.service';
import { LanguageService } from '../../../../core/language.service';
import { AccountService } from '../../../../core/account.service';
import { UserDetails } from '../../models';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, TooltipModule, TranslateModule, ButtonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  private auth = inject(AuthService);
  private account = inject(AccountService);
  lang = inject(LanguageService);
  constructor(public router: Router) {}

  me: UserDetails | null = null;
  imageBroken = false;

  ngOnInit() {
    if (this.isAuthenticated) {
      this.loadProfile();
    }
  }

  private loadProfile() {
    this.account.getMyProfile().subscribe({
      next: (u) => {
        this.me = u;
        this.imageBroken = false;
      },
      error: () => {
        this.me = null;
      },
    });
  }

  switchLang() {
    this.lang.toggle();
  }

  get isAuthenticated(): boolean {
    return this.auth.isAuthenticated();
  }

  /** Initials fallback (first letter of first/last name, or username). */
  get initials(): string {
    const f = this.me?.firstName?.trim() || '';
    const l = this.me?.lastName?.trim() || '';
    if (f || l) return ((f[0] || '') + (l[0] || '')).toUpperCase();
    const u = this.me?.username?.trim() || '';
    return u.slice(0, 2).toUpperCase();
  }

  get displayName(): string {
    return this.me?.fullName?.trim() || this.me?.username || '';
  }

  onImageError() {
    this.imageBroken = true;
  }

  async logout() {
    await this.auth.logout();
  }
}
